import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Button, Tabs } from "antd";
import "../../header/headerWithAuth/HeaderBottomMenu.scss";
import Employer from "../EmployerList/Employer";
// import StudentListTable from '../../studentListTable';
import StudentList from "../StudentList/StudentList";
import "./PlacementHome.scss";
import JobsUnderEvent from "../JobsUnderEvent/jobsUnderEvent";
const { TabPane } = Tabs;

function PlacementHome() {
  
  const navigate = useNavigate();
  const location = useLocation();
  const eventName = location.state?.eventName;
 

  const [current, setCurrent] = useState("");
  const { eventId } = useParams();
  const activeTabKey = localStorage.getItem('activeTabKey')

  const handleTabClick = (key) => {
    localStorage.setItem('activeTabKey', key)
  };

  useEffect(() => {
    setCurrent(location.pathname);

  }, [location.pathname]);


  return (
    <div className="home">
      <div className="headingContainer">
        <div className="headingTitle">
          <h3>{eventName}</h3>
        </div>
        <div className="headingButton">
          <Button onClick={() => navigate(-1)} type="primary">
            Back
          </Button>
        </div>
      </div>

      <Tabs defaultActiveKey={activeTabKey} onTabClick={handleTabClick}>
        <Tabs.TabPane tab="Employers" key="/pemployers">

          <Employer eventId={eventId} />

        </Tabs.TabPane>
        <Tabs.TabPane tab="Students" key="/pstudents">

          <StudentList eventId={eventId} />

        </Tabs.TabPane>
        <Tabs.TabPane tab="Jobs" key="/pjobs">
          {/* Content for Students */}
          <JobsUnderEvent eventId={eventId} />
          {/* <Link to="/pstudents"></Link> */}
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
}

export default PlacementHome;
